// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"ff966c00","44":"58f6073c","115":"a41f067d","354":"64c4d43d","569":"af3a9de0","628":"2478506a","693":"6c4e5949","833":"efcb7165"}[chunkId] + ".chunk.js";
};